export default __webpack_public_path__ + "static/media/rainforest3.85fcc2c1.jpg";